import { render } from "./PaymentTemplate.vue?vue&type=template&id=7c927c3e"
import script from "./PaymentTemplate.vue?vue&type=script&lang=js"
export * from "./PaymentTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__